module.exports = __webpack_public_path__ + "img/apidays-2021-banner.bea8b2fa.jpg";